import styled from '@emotion/styled'

import { NativeLink, palette, spacing, Text, typography } from 'main/ui'

export const Container = styled.div`
  width: 20rem;
  padding: ${spacing.majorScale(2)}px ${spacing.majorScale(2)}px;
  background-color: ${palette.lightGray};
`

export const Title = styled(Text)`
  font-weight: ${typography.fontWeight.bold};
`

export const PhoneLink = styled(NativeLink)`
  white-space: nowrap;
`
